import { ToggleGroup, ToggleGroupItem } from '~/common/components/ui/toggle-group';
import { Tooltip, TooltipContent, TooltipTrigger } from '~/common/components/ui/tooltip';
import { Grid2X2, Rows3 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '~/common/utils/styleUtil.ts';

export interface CatalogViewSwitcherProps {
  showTileView: boolean;
  onViewTypeChange: (showTileView: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export function CatalogViewSwitcher({ showTileView, onViewTypeChange, disabled, className }: Readonly<CatalogViewSwitcherProps>) {
  const { t } = useTranslation();

  const handleViewChange = (view: 'list' | 'tile') => {
    onViewTypeChange(view === 'tile');
  };

  const value = showTileView ? 'tile' : 'list';

  return (
    <ToggleGroup
      type="single"
      value={value}
      size={'sm'}
      className={cn('justify-end', className)}
      onValueChange={handleViewChange}
      disabled={disabled}
    >
      <ToggleGroupItem value="tile">
        <Tooltip>
          <TooltipTrigger asChild={true} data-testid={'catalog-view-list'}>
            <Grid2X2 />
          </TooltipTrigger>
          <TooltipContent>{t('Kachelansicht')}</TooltipContent>
        </Tooltip>
      </ToggleGroupItem>
      <ToggleGroupItem value="list">
        <Tooltip>
          <TooltipTrigger asChild={true} data-testid={'catalog-view-tile'}>
            <Rows3 />
          </TooltipTrigger>
          <TooltipContent>{t('Listenansicht')}</TooltipContent>
        </Tooltip>
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
